"use client";

// src/components/upload/upload-preview.tsx
import { CircleLoader } from "@cat-home-experts/mortar-iconography-web/CircleLoader";
import { CloseCircleFill } from "@cat-home-experts/mortar-iconography-web/CloseCircleFill";
import { tv } from "tailwind-variants";
import { Button } from "../button/button.mjs";
import { Link } from "../link/link.mjs";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var uploadPreviewStyle = tv({
  base: "relative size-full overflow-hidden rounded-lg border",
  variants: {
    error: {
      true: "border-primary-700"
    }
  }
});
function UploadPreview({
  files,
  removeFile
}) {
  if (files.length === 0) {
    return null;
  }
  return /* @__PURE__ */ jsx("div", { className: "grid grid-cols-3 place-items-center justify-around gap-4 sm:grid-cols-4 py-3", children: files.map((file) => /* @__PURE__ */ jsxs(
    "div",
    {
      className: uploadPreviewStyle({ error: !!file.error }),
      children: [
        /* @__PURE__ */ jsx(
          Link,
          {
            href: file.url,
            target: "_blank",
            className: "bg-main/30 backdrop-blur-sm",
            children: /* @__PURE__ */ jsx(
              "img",
              {
                src: file.url,
                alt: file.name ?? "Preview",
                width: 98,
                height: 98,
                className: "aspect-square w-full object-cover"
              }
            )
          }
        ),
        file.pending && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx("div", { className: "absolute inset-0 bg-main/50 backdrop-saturate-50 " }),
          /* @__PURE__ */ jsx("div", { className: "absolute inset-0 flex items-center justify-center", children: /* @__PURE__ */ jsx(
            CircleLoader,
            {
              role: "presentation",
              className: "animate-spin duration-75",
              size: 20,
              color: "#fff"
            }
          ) })
        ] }),
        file.id && /* @__PURE__ */ jsx(
          Button,
          {
            className: "absolute right-0 top-0 !size-5 max-h-5 min-h-5 min-w-5  fill-neutral-200 !p-0 text-[10px] hover:fill-neutral-600",
            variant: "unstyled",
            iconOnly: true,
            "aria-label": `Remove ${file.name}`,
            size: "lg",
            onClick: () => removeFile(file.id),
            children: /* @__PURE__ */ jsx(CloseCircleFill, { size: 20, className: "size-5 min-h-5 min-w-5" })
          }
        )
      ]
    },
    file.url
  )) });
}
export {
  UploadPreview
};
